import { Button, Form, ListGroup } from 'react-bootstrap';
import { useRef, useState } from 'react';
import { useOutletContext } from 'react-router';
import { faMagnifyingGlass, faCircleXmark as lightXmark } from '@fortawesome/pro-light-svg-icons';
import { faCircleXmark as solidXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useActivitySearchContext } from '../../context';
import HesSpinner from '../../../../components/loadingOverlay/hesSpinner';
import CustomToast from '../../../../components/Toast';
import '../../../../pages/questionsSearch/questionsSearch.scss';

const VocabularyId = () => {
  const [keyword, setKeyword] = useState('');
  const outletContext = useOutletContext();
  const [clearHover, setClearHover] = useState(false);
  const searchBoxRef = useRef();
  const activitySearchContext = useActivitySearchContext();

  const handleVocabularyIdChange = (e) => {
    if (e.target.value.length > 0) {
      e.target.value = e.target.value.replace(/\D/g, '');
    }

    setKeyword(e.target.value);
  };

  const SearchQuestions = () => {
    if (keyword > 2147483647) {
      CustomToast('Invalid vocabulary ID', 'error');
      return;
    }

    var searchRequest = {
      keyword: keyword,
      pageNumber: 1,
      pageSize: 25,
      courseIds: [],
      levels: []
    };

    activitySearchContext.setShowResults(true);
    activitySearchContext.setApiParams(searchRequest);
    activitySearchContext.setApiIdentifier('vocabularyIdSearch');
  };

  const handleClearSearch = () => {
    searchBoxRef.current.value = '';
    searchBoxRef.current.focus();
    setKeyword('');
  };

  return (
    <div className='d-flex flex-row gap-2 align-items-center castleQuestionsSearchBox'>

      {outletContext.courseFilters.isError && <div className='d-flex w-100 justify-content-center align-items-center'>
        <button className='dataFetchError' onClick={() => outletContext.fetchCourseFilters()}>There was an error getting your courses. Click to try again</button>
      </div>}

      {outletContext.courseFilters.isLoading && <div className='d-flex flex-row w-100 justify-content-center align-items-center'>
        <HesSpinner width='2%' />
        <span className='ms-2 fs-2'>Getting your courses...</span>
      </div>}

      {!outletContext.courseFilters.isError && !outletContext.courseFilters.isLoading &&
        <>
          <ListGroup.Item className='mx-1 w-100'>
            <Form.Group>
              <div>
                <Form.Control className='px-5' type='text' placeholder='Vocabulary ID' ref={searchBoxRef}
                  onChange={(e) => handleVocabularyIdChange(e)}
                  onKeyUp={(e) => { if (keyword?.length > 0 && e.key == 'Enter') SearchQuestions(); }}
                />
                <FontAwesomeIcon className='searchIcon' icon={faMagnifyingGlass} />
                <FontAwesomeIcon className={`clearSearchIcon ${keyword?.length > 0 ? '' : 'd-none'}`}
                  icon={clearHover ? solidXmark : lightXmark}
                  onMouseEnter={() => setClearHover(true)}
                  onMouseLeave={() => setClearHover(false)}
                  onClick={() => handleClearSearch()} />
              </div>
            </Form.Group>
          </ListGroup.Item>
          <Button variant='castleWhite btn-width' disabled={activitySearchContext.isSearching || keyword?.length <= 0} onClick={() => SearchQuestions()}>Search</Button>
        </>
      }
    </div>
  );
};

export default VocabularyId;
